import React from 'react';
import { useLocation } from 'react-router-dom';
import BookLocationPage from './BookLocationPage';
import FullScreenDialog from '../../common/FullScreenDialog';
import { useGetLocationListQuery } from "../../../api/locations/locationsApiSlice";
import { useBookingFlowLifecycle } from "../common/hooks/useBookingFlowLifecycle";
import { useBookingUrlState } from "../common/hooks/useBookingUrlState";
import { useIsObjectFirst } from "../common/hooks/useObjectFirstEntry";
import { DEFAULT_EVENT_FLOW_USE_CASE, EventFlowUseCaseProvider } from "./eventFlowUseCase";
import type { UseCase } from "../../../util/useCases";

interface BookLocationDialogProps {
    open: boolean;
    locationId?: string;
    /** The event-flow use case this dialog books: venue (`/venue/book`) or
     *  hall (`/hall/book`), which runs the same flow (PO, 2026-10-18). */
    useCase?: UseCase;
}


const VenueReservationDialog = ({ useCase = DEFAULT_EVENT_FLOW_USE_CASE, ...props }: BookLocationDialogProps) => {
    const location = useLocation();
    const { returnPage } = location.state || {};

    // Note: It's currently important that BookLocationPage is only mounted when location is available
    // due to body scroll locking

    const { data: locations } = useGetLocationListQuery(useCase);

    // Lifecycle must run before URL state: date reducers gate nextEnabled
    // on the flow's use case being an event (`flowUseCase` of
    // `state.useCase`, here the dialog's own use case), which lifecycle sets.
    useBookingFlowLifecycle({ useCase, locations });
    useBookingUrlState({
        timeOfDay: true,
        eventType: true,
        pinObjectId: useIsObjectFirst(useCase),
    });

    return (
        <EventFlowUseCaseProvider value={useCase}>
            <FullScreenDialog open={props.open}>
                {<BookLocationPage returnPage={returnPage} />}
            </FullScreenDialog>
        </EventFlowUseCaseProvider>
    );
};

export { VenueReservationDialog };
